import { trackFullscreen } from '@leprecoins/effector';
import { createEvent } from 'effector';

const setup = createEvent();

export const fullscreen = Object.assign(trackFullscreen({ setup }), { setup });
